import React from "react";
import "./SectionFive.css";

export default function SectionFive() {
  return (
    <div className="section-five">
      <img
        src="/img/section-five-right-line.svg"
        className="img-fluid section-five-right-line"
        alt=""
      />
      <img
        src="/img/section-five-left-line.svg"
        className="img-fluid section-five-left-line"
        alt=""
      />
      <div className="container-fluid">
        <div className="row mx-0 px-0">
          <div className="col-12 d-flex justify-content-center">
            <span className="section-five-h1">Customer Testimonials</span>
          </div>
        </div>
        <div className="row mx-0 px-0">
          <div className="container-fluid section-five-content">
            <div className="row">
              <div className="col-lg-6">
                <div className="card section-five-card " id="gradient-color">
                  <div className="card-body section-five-card-body">
                  <div>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i className="bi bi-star-fill"
                          style={{color: "black", fontSize: "30px"}}></i>
                        </div>
                    <p className="mt-4">
                    <i class="bi bi-quote"></i> <i>My wife and I had an exceptional experience with Deal
                      Direct Homes while buying our new home. Referred by a
                      family friend, we quickly realized that DDH is the
                      ultimate “one-stop shop” for everything related to the
                      home-buying process. By taking advantage of the
                      all-encompassing services DDH offers, like the ability to
                      make a direct offer, not paying any unnecessary Realtor
                      commissions and associating us with a fantastic lender, we
                      ended up saving several thousand dollars. The most
                      significant achievement, however, was closing our new home
                      and getting our keys in just 7 days! A huge thank you to
                      Deal Direct Homes for transforming what could have been a
                      stressful process into a smooth and straightforward
                      experience, all while addressing our (my) questions along
                      the way.</i> <i class="bi bi-quote" style={{transform: "rotate(180deg)", display: "inline-block"}}></i>
                    </p>
                    <div className="tertimonial-user-1">
                      <hr
                        style={{
                          backgroundColor: "#ffffff!important",
                          color: "#ffffff",
                          height: "2px",
                        }}
                      />
                      {/* <p className="tertimonial-user-1">
                      Steve and Brenda <br /> M. Fresno, CA
                    </p> */}
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div>
                          <p className="mb-0">
                            Steve and Brenda M.<br />
                            Fresno, CA
                          </p>
                        </div>
                        {/* <div>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card section-five-card-2" id="gradient-color-2">
                  <div className="card-body section-five-card-body">
                  <div>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "black", fontSize: "30px" }}
                          ></i>
                          <i className="bi bi-star-fill"
                          style={{color: "black", fontSize: "30px"}}></i>
                        </div>
                    <p className="mt-4">
                    <i class="bi bi-quote"></i> <i>We recently purchased a second home using the Deal Direct
                      Homes system. We were so excited to get the home we wanted
                      and saved tons of money all in about 20 days. The process
                      was easy and seamless. Thank you DDH!</i> <i class="bi bi-quote" style={{transform: "rotate(180deg)", display: "inline-block"}}></i>
                    </p>
                    <div className="tertimonial-user-2">
                      <hr
                        style={{
                          backgroundColor: "#ffffff!important",
                          color: "#ffffff",
                          height: "2px",
                        }}
                      />
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div>
                          <p className="mb-0">
                            Desiree A. Mills, RN, MSN, FNP-C <br />
                            Ladera Ranch, CA
                          </p>
                        </div>
                        {/* <div>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i
                            className="bi bi-star-fill"
                            style={{ color: "#d4bb98" }}
                          ></i>
                          <i className="bi bi-star-fill"
                          style={{color: "#d4bb98"}}></i>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
